import React from 'react';
import './TestimonialsSection.css';

const testimonials = [
    {
        name: "Anonymous Student",
        role: "Stanford University",
        testimonial: "I'm worried that I'm going to graduate and not be able to make the most of Stanford.",
    },
    {
        name: "Anonymous Student",
        role: "Massachusetts Institute of Technology",
        testimonial: "I've never met my master's mentor. I've emailed her---she did not get back to me.",
    },
    {
        name: "Anonymous Student",
        role: "Arizona State University",
        testimonial: "My Academic Advisor screwed me. I had to say at school for another semester for one class and spend an extra $30k.",
    },
];

const TestimonialsSection = () => {
    return (
        <div id="testimonials" className="testimonials-section">
            <h2>What Our Users Say</h2>
            <div className="testimonials-carousel">
                {testimonials.map((item, index) => (
                    <div key={index} className="testimonial-card">
                        <p className="testimonial-quote">"{item.testimonial}"</p>
                        <h4 className="testimonial-name">{item.name}</h4>
                        <p className="testimonial-role">{item.role}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TestimonialsSection;